import { render } from "./SignUpForm.vue?vue&type=template&id=8c3c9972&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=8c3c9972&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8c3c9972"

export default script